import type { PlaybookPlace } from '../lib/places';
import { useTicketRulesCatalog } from '../hooks/use-ticket-rules';
import { TemplateGallery } from './template-gallery';

/** The template gallery, mounted only for a brand with playbooks on so other brands never fetch the catalog. */
export function PlaybookTemplates({ open, onOpenChange, place }: { open: boolean; onOpenChange: (open: boolean) => void; place: PlaybookPlace }) {
	const catalog = useTicketRulesCatalog().data;
	return catalog ? <TemplateGallery open={open} onOpenChange={onOpenChange} catalog={catalog} place={place} /> : null;
}
